import AssistantText from './AssistantText.vue';

export default AssistantText;
